<template>
  <div
    class="vmp-interact-menu"
    :class="[className, disable ? 'disable' : '']"
    :style="{ display: hidden ? 'none' : 'flex' }"
    v-if="roleName != 4 || (roleName == 4 && !auth_gd)"
  >
    <div class="vmp-interact-menu-icon">
      <i class="vh-saas-iconfont vh-saas-a-line-Interactivetools"></i>
      <p>{{ $t('interact_tools.interact_tools_1152') }}</p>
    </div>
    <div class="vmp-interact-menu-wrap" v-if="!disable" :class="[auth_gd ? 'gd' : '']">
      <div class="vmp-interact-menu-list">
        <div
          class="vmp-interact-menu-list-item"
          @click="openLottery"
          v-if="configList['ui.hide_lottery'] && !auth_gd"
        >
          <i class="vh-iconfont vh-a-line-luckydraw"></i>
          <p>{{ $t('interact_tools.interact_tools_1003') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="openSign"
          v-if="configList['ui.hide_sign_in'] && !auth_gd"
        >
          <i class="vh-iconfont vh-line-order"></i>
          <p>{{ $t('interact_tools.interact_tools_1024') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="emitOpenQuestionnaire"
          v-if="configList['ui.hide_survey'] && !auth_gd"
        >
          <i class="vh-iconfont vh-line-questionnaire"></i>
          <p>{{ $t('form.form_1074') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="emitOpenExam"
          v-if="configList['exam'] && !auth_gd"
        >
          <i class="vh-iconfont vh-a-line-Sentaanswer"></i>
          <p>{{ $t('exam.exam_1047') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          :class="{ 'vmp-interact-menu-list-disable': !isLiving }"
          @click="handleQAPopup"
          v-if="configList['ui.is_hide_qa_button'] && !auth_gd"
        >
          <i class="vh-iconfont vh-a-line-qanda"></i>
          <p>{{ $t('common.common_1004') }}</p>
        </div>
        <!-- 支付牌照问题 -->
        <div
          class="vmp-interact-menu-list-item"
          :class="{ 'vmp-interact-menu-list-disable': !isLiving }"
          @click="openRedPacket"
          v-if="configList['ui.show_redpacket'] && !auth_gd"
        >
          <i class="vh-iconfont vh-a-line-redpacket"></i>
          <p>{{ $t('interact_tools.interact_tools_1098') }}</p>
          <!-- <vmp-air-container cuid="" :oneself="true"></vmp-air-container> -->
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="openTimer"
          :class="{ 'vmp-interact-menu-list-disable': !isLiving }"
          v-if="configList['webinar.timer'] && !auth_gd"
        >
          <i class="vh-iconfont vh-line-time"></i>
          <p>{{ $t('interact_tools.interact_tools_1099') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="emitOpenCard"
          v-if="configList['push_screen_card'] && !auth_gd"
        >
          <i class="vh-saas-iconfont vh-saas-line-card"></i>
          <p>{{ $t('interact_tools.interact_tools_1122') }}</p>
        </div>
        <template v-if="pendantInfo">
          <div
            class="vmp-interact-menu-list-item"
            :class="{ 'vmp-interact-menu-list-disable': !isLiving }"
            @click="emitOpenCard_GD(item)"
            :key="item.id"
            v-for="item in pendantInfo.custom_pendant_list"
          >
            <!-- <i class="vh-saas-iconfont vh-saas-line-card"></i> -->
            <img v-if="isLiving" class="p_icon normal" :src="item.icon" alt="" />
            <img v-if="isLiving" class="p_icon active" :src="item.active_icon" alt="" />
            <img v-if="!isLiving" class="p_icon dis" :src="item.disable_icon" alt="" />
            <p>{{ item.name }}</p>
          </div>
        </template>

        <div
          class="vmp-interact-menu-list-item"
          :class="{ 'vmp-interact-menu-list-disable': !isLiving || isThirdStream }"
          @click="openRebroadcast"
          v-if="(!isNoDelay || webinarMode == 2) && configList['rebroadcast'] && !auth_gd"
        >
          <i class="vh-saas-iconfont vh-saas-a-color-Playbackmanagement"></i>
          <p>{{ $t('interact_tools.interact_tools_1153') }}</p>
        </div>
        <div class="vmp-interact-menu-list-item" @click="openAIChat" v-if="configList['ai_chat']">
          <i class="iconfont-v3 saasline-AI1"></i>
          <p>{{ $t('interact_tools.interact_tools_1154') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="openWatchReward"
          v-if="configList['watch_gift'] && !auth_gd"
        >
          <i class="vh-iconfont vh-guankanyouli"></i>
          <p>{{ $t('interact_tools.interact_tools_1151') }}</p>
        </div>
        <div class="vmp-interact-menu-list-item" @click="isRedPacket = true" v-if="hasWatchGift">
          <i class="vh-iconfont vh-a-line-redpacket"></i>
          <p>{{ $t('interact_tools.interact_tools_1155') }}</p>
        </div>
        <div
          class="vmp-interact-menu-list-item"
          @click="isMallReward = true"
          v-if="configList['mall_reward'] && !auth_gd"
        >
          <i class="vh-iconfont vh-a-line-mallreward"></i>
          <p>{{ $t('interact_tools.interact_tools_1156') }}</p>
        </div>

        <div
          class="vmp-interact-menu-list-item"
          @click="isInactiveKick = true"
          v-if="configList['inactive_kick'] && !auth_gd"
        >
          <i class="vh-saas-iconfont vh-saas-line-blacklist"></i>
          <p>{{ $t('interact.interact_1049') }}</p>
        </div>
      </div>
    </div>
    <VmpAIChatList></VmpAIChatList>
    <VmpPendantCard @getPendantInfo="getPendantInfo"></VmpPendantCard>
    <CashRedPacket
      v-if="isRedPacket"
      @close="isRedPacket = false"
      :dialogVisible.sync="isRedPacket"
      :webinarId="webinarId"
    ></CashRedPacket>
    <MallReward
      v-if="isMallReward"
      @close="isMallReward = false"
      :dialogVisible.sync="isMallReward"
      :webinarId="webinarId"
    ></MallReward>

    <!-- 观看有礼 -->
    <WatchGift v-if="hasWatchGift"></WatchGift>

    <!-- 踢出直播 -->
    <InactiveKickMain
      v-if="isInactiveKick"
      @close="isInactiveKick = false"
      :dialogVisible.sync="isInactiveKick"
      :webinarId="webinarId"
    ></InactiveKickMain>
  </div>
</template>
<script>
  import { useQaServer, useRoomBaseServer, useMsgServer } from 'middle-domain';
  import { boxEventOpitons } from '@/app-shared/utils/tool.js';
  //AI
  import VmpAIChatList from '@/packages/AI-chat/list';
  import VmpPendantCard from '@/packages/pendant/card';

  export default {
    name: 'VmpInteractMenu',
    components: {
      VmpAIChatList,
      VmpPendantCard,
      CashRedPacket: () => import('@/packages/cash-redpacket/live.vue'),
      MallReward: () => import('@/packages/mall-reward/src/live/live.vue'),
      WatchGift: () => import('@/packages/watch-gift/live/index.vue'),
      InactiveKickMain: () => import('@/packages/inactive-kick/live/main.vue')
    },
    data() {
      return {
        living: false,
        className: '', // 自定义样式
        kind: '', // 类型
        disable: false, // 是否禁用
        hidden: false, // 是否隐藏
        disTimer: false,
        hoverCard: false,
        pendantInfo: null,
        isRedPacket: false,
        isMallReward: false,
        isInactiveKick: false
      };
    },
    computed: {
      hasWatchGift() {
        return this.configList['watch_gift'] && !this.auth_gd;
      },
      // 当前用户角色 1-主持人 2-观众(发起端没有观众) 3-助理；4-嘉宾（互动直播才有嘉宾）
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      //互动工具状态
      interactToolStatus() {
        const { interactToolStatus = {} } = this.$domainStore.state.roomBaseServer;
        return interactToolStatus;
      },
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      // 是否为第三方发起
      isThirdStream() {
        return this.$domainStore.state.roomBaseServer.isThirdStream;
      },
      // 无延迟 Type:Boolean
      isNoDelay() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.no_delay_webinar === 1;
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      configList() {
        let configList = this.$domainStore.state.roomBaseServer.configList;
        return configList;
      },
      // 直播模式：1-音频直播、2-视频直播、3-互动直播 6-分组直播 5 定时直播
      webinarMode() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.mode;
      },
      webinarId() {
        return this.$domainStore.state.roomBaseServer?.watchInitData?.webinar?.id;
      }
    },
    beforeCreate() {
      this.roomBaseServer = useRoomBaseServer();
    },
    mounted() {
      this.QAName = this.interactToolStatus.question_name;
      this.listenEvents();
    },
    methods: {
      listenEvents() {
        const msgServer = useMsgServer();
        const qaServer = useQaServer();
        msgServer.$on('live_over', () => {
          this.isQAEnabled = false;
          this.qaVisible = false;
        });
        qaServer.$on(qaServer.Events.QA_OPEN, msg => {
          this.isQAEnabled = true;
        });
        qaServer.$on(qaServer.Events.QA_CLOSE, msg => {
          this.isQAEnabled = false;
        });
        qaServer.$on(qaServer.Events.QA_SET, msg => {
          this.QAName = msg.name;
        });
      },
      // 设置可用状态
      setDisableState(val) {
        this.disable = val;
      },
      // 设置显示隐藏状态
      setHiddenState(val) {
        this.hidden = val;
      },
      // 打开计时器设置弹框
      openTimer() {
        if (this.disTimer || !this.isLiving) return false;
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenTimerSet'));
      },
      //  打开转播
      openRebroadcast() {
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenRebroadcast'));
      },
      // 更改禁用状态
      changeStatus(data, status) {
        // console.log(data, status, 'data, status');
        this[data] = status;
      },
      // 打开抽奖弹窗
      openLottery() {
        // if (!this.isLiving) return false;
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenLottery'));
      },
      // 打开问卷弹窗
      emitOpenQuestionnaire() {
        window.vhallReportForProduct && window.vhallReportForProduct.report(110060);
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenQuestionnaire'));
      },
      // 打开快问快答弹窗
      emitOpenExam() {
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenExam'));
      },
      // 打开推屏卡片
      emitOpenCard() {
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenCard'));
      },
      // 打开签到弹窗
      openSign() {
        // if (!this.isLiving) return false;
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenSign'));
      },
      //打开观看有礼列表
      openWatchReward() {
        this.$emitter.emit(this.$EMIT_DEFINE.watch_gift_main, true);
      },
      // 打开红包弹窗
      // TODO:支付牌照问题
      openRedPacket() {
        // console.log('点击红包');
        if (!this.isLiving) return false;
        // this.$message.warning('合规自查中，该功能暂不支持使用');
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitOpenRedPacket'));
      },
      handleQAPopup() {
        if (!this.isLiving) return false;
        window.$middleEventSdk?.event?.send(boxEventOpitons(this.cuid, 'emitHandleQA'));
      },
      openAIChat() {
        //打开AI聊天
        this.$emitter.emit(this.$EMIT_DEFINE.ai_chat_open);
      },
      emitOpenCard_GD(item) {
        if (!this.isLiving) return false;
        //打开推屏挂件
        this.$emitter.emit(this.$EMIT_DEFINE.gd_card_open, item);
      },
      getPendantInfo(info) {
        this.pendantInfo = info || null;
      }
    }
  };
</script>
<style lang="less">
  .vmp-interact-menu {
    position: relative;
    justify-content: center;

    &-icon {
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      padding: 10px 0px;
      cursor: pointer;
      color: #ececec;
      text-align: center;
      i {
        user-select: none;
        display: block;
        width: 23px;
        height: 23px;
        margin: 0 auto;
        padding-bottom: 6px;
        font-size: 22px;
      }
      p {
        font-size: 12px;
      }
      &:hover {
        color: #fb3a32;
      }
    }
    &:hover {
      .vmp-interact-menu-wrap {
        display: block;
      }
    }
    &.disable {
      cursor: default;
      i,
      p {
        color: #777777;
      }
      .vmp-interact-menu {
        &-icon {
          cursor: default;
        }
      }

      &:hover {
        .vmp-interact-menu-wrap {
          display: none;
        }
      }
    }

    &-wrap {
      display: none;
      position: absolute;
      left: 58px;
      top: 0;
      width: 182px;
      background: #434343;
      z-index: 2;
      border-radius: 4px;
      box-sizing: border-box;
      border: 1px solid #2d2d2d;
      padding: 0 10px 20px 10px;
      z-index: 110;
      &.gd {
        width: max-content;
        max-width: 182px;
      }
    }
    &-list {
      display: flex;
      flex-wrap: wrap;
      &-item {
        flex-shrink: 0;
        width: 52px;
        margin-top: 20px;
        font-size: 12px;
        color: #ececec;
        text-align: center;
        cursor: pointer;
        i {
          display: block;
          margin: 0 auto;
          font-size: 16px;
          padding-bottom: 4px;
        }
        &:hover {
          color: #fb3a32;
          .p_icon {
            &.active {
              display: block;
            }
            &.normal {
              display: none;
            }
          }
        }
        img {
          width: 16px;
          height: 16px;
          padding: 2px;
          margin-bottom: 4px;
        }
        .p_icon {
          display: none;
          margin: 0 auto;
          padding-bottom: 4px;
          &.dis {
            display: block;
          }
          &.normal {
            display: block;
          }
        }
      }
      &-disable {
        pointer-events: none; // 不可点击
        i,
        p {
          color: #777777;
        }
        pointer-events: none;
      }
    }
  }
  .qa_modal {
    .vh-dialog__body {
      min-height: 80px;
    }
    .qa_content {
      .qa_content_txt {
        padding-bottom: 10px;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        color: #666666;
        word-break: break-word;
        overflow-wrap: break-word;
        white-space: normal;
      }
      .qa_content_form {
        padding-top: 6px;
        .vh-form-item__label {
          color: #1a1a1a;
          line-height: 40px;
        }
      }
      .qa_name_item {
        margin: 0;
        .qa_name {
          min-width: 240px;
        }
      }
    }
    .vh-dialog__footer {
      padding-top: 0;
    }
    .enable_qa_btn {
      text-align: right;
    }
  }
</style>
